import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExpandRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.7803 5.46967C13.4874 5.17678 13.0126 5.17678 12.7197 5.46967C12.4268 5.76256 12.4268 6.23744 12.7197 6.53033L18.1893 12L12.7197 17.4697C12.4268 17.7626 12.4268 18.2374 12.7197 18.5303C13.0126 18.8232 13.4874 18.8232 13.7803 18.5303L19.7803 12.5303C20.0732 12.2374 20.0732 11.7626 19.7803 11.4697L13.7803 5.46967Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.78033 5.46967C5.48744 5.17678 5.01256 5.17678 4.71967 5.46967C4.42678 5.76256 4.42678 6.23744 4.71967 6.53033L10.1893 12L4.71967 17.4697C4.42678 17.7626 4.42678 18.2374 4.71967 18.5303C5.01256 18.8232 5.48744 18.8232 5.78033 18.5303L11.7803 12.5303C12.0732 12.2374 12.0732 11.7626 11.7803 11.4697L5.78033 5.46967Z",
		fill: "currentColor"
	})]
});
export { SvgIconExpandRight as ReactComponent };
